import { tenantSettingsAPI } from '@/providers/apis/tenant-settings/tenant-settings';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import TenantSettingElement from '@/components/tenant-settings/tenant-settings';
import axios from 'axios';
import { TENANT_SETTINGS_KEYS } from '@/utils/tenant-setting';
import SSOConfirmationPopup from '@/components/cards/sso-confirmation-popup/sso-confirmation-popup';
import { checkCDNUrl, diffArray, isEmptyValue, sortByProperty } from '@/utils/utils';
import { TENANT_DEFAULT } from '@/utils/constants';
import { mediaAPI } from '@/providers/apis/media/media';
import { EventBus } from '@/main';
import { sessionService } from '@/providers/services/auth/session';
import { taxonomyAPI } from '@/providers/apis/taxonomy/taxonomy';

@Component({
    name: 'tenant-settings-loader',
    components: TenantSettingElement,
})

export default class TenantSettingsLoader extends Vue {

    // ---------------------------------------------------------------------------------
    // Properties

    @Prop({ default: 'roster' })
    private activeSettings!: any;

    @Prop()
    private selectedTenant!: any;

    private isShowConfirmationPullup: any = false;


    private tenantElement: any = null;

    private tenantSettings: any = {};

    private tenantSettingsOriginals: any = {};

    private tenantSettingComponents: any = {};

    private tenantKeys: any = TENANT_SETTINGS_KEYS;

    private isLoading: boolean = false;

    private updatedItemArray: any = [];

    private selectedTenantSettings: any = [];

    private defaultTenantSettings = TENANT_DEFAULT;

    private isUpdating = false;

    private enableSaveButton: any = ['whiteLabeling', 'classSettings'];

    private settingsHasMultipleSettings = ['ui_element_visibility_settings'];

    private categoryList: any = [];

    private displayTenantSettings: any = [];

    @Watch('$route.params')
    private onChangeQuery() {
        this.tenantElement = [];
        this.isLoading = true;
        this.fetchTenantSettings();
    }

    @Watch('selectedTenant')
    private changeTenant(value: any) {
        this.getCategorySubject();
        this.fetchTenantSettings();
    }

    // ---------------------------------------------------------------------------------
    // Hooks

    private created() {
        this.getCategorySubject();
        this.fetchTenantSettings();
    }

    // ---------------------------------------------------------------------------------
    // Actions


    // ---------------------------------------------------------------------------------
    // Methods

    private loadComponent() {
        this.tenantSettings = JSON.parse(JSON.stringify(this.tenantSettingsOriginals));
        const settingsComponent = this.tenantSettingComponents;
        const activeComponent = settingsComponent[this.activeSettings] || {};
        sortByProperty(activeComponent, 'sequenceId', 'ASC');
        this.checkDefaultDDSelection(activeComponent);
        this.tenantElement = activeComponent;
        this.updatedItemArray = [];
        this.selectedTenantSettings = [];
    }

    private fetchTenantSettings() {
        this.isLoading = true;
        axios.all([
            tenantSettingsAPI.fetcTenantConfigKeys(),
            tenantSettingsAPI.fetchActiveTenantSettings(),
        ]).then(axios.spread((settingComponent: any, settingsList: any) => {
            const settingsComponent = settingComponent;
            if (settingsList.roster_format && settingsList.roster_format === 'third_party_sync') {
                const rosterSetingIndex = settingComponent.classSettings.findIndex((item: any) => {
                    return item.settingKey === 'show_class_roster_sync_control';
                });
            } else {
                const rosterSetingIndex = settingComponent.classSettings.findIndex((item: any) => {
                    return item.settingKey === 'show_class_roster_sync_control';
                });
                if (rosterSetingIndex !== -1) {
                    settingComponent.classSettings.splice(rosterSetingIndex, 1);
                }
            }
            const activeComponent = settingsComponent[this.activeSettings] || {};
            for (const iterator of activeComponent) {
                if (iterator.parentKey && iterator.parentKey !== 'null' &&
                    isEmptyValue(settingsList[iterator.parentKey])) {
                    settingsList[iterator.parentKey] = {};
                }
            }
            this.tenantSettingComponents = settingComponent;
            this.tenantSettingsOriginals = settingsList;
            this.tenantSettings = JSON.parse(JSON.stringify(settingsList));
            this.loadComponent();
            this.isLoading = false;
        }));

    }

    private onSaveSettings(group: any) {
        this.getUpdatedSettings();
        // this.$bvModal.show('tenant-confirmation');
    }

    private hideModal() {
        this.selectedTenantSettings = [];
        this.$bvModal.hide('tenant-confirmation');
    }

    private getVisiblitySetting(settingsKey: any, isParentAvailable: any) {
        const itemIndex: any = this.selectedTenantSettings.findIndex((item: any) => {
            if (isParentAvailable) {
                return item.parentKey === settingsKey;
            } else {
                return item.keyName === settingsKey;
            }
        });
        if (itemIndex !== -1) {
            return this.selectedTenantSettings[itemIndex].settingVisibility;
        }
    }

    private async uploadImage(iterator: any) {
        return mediaAPI.uploadFile(iterator.selectedItems, 'image').then((fileData) => {
            return checkCDNUrl(fileData.filename);
        });
    }

    private async onUpdate() {
        const that = this;
        const tenantElement = this.tenantElement;
        const sendData: any = [];
        let tenantObj: any = {};
        const updatedSettings = JSON.parse(JSON.stringify(this.selectedTenantSettings)) || [];
        this.isUpdating = true;
        for await (const iterator of this.selectedTenantSettings) {
            if (iterator.selectedItems instanceof File) {
                iterator.selectedItems = await this.uploadImage(iterator);
            }
        }
        const tenantSettingsOriginals = JSON.parse(JSON.stringify(this.tenantSettingsOriginals));
        tenantObj = this.selectedTenantSettings.reduce((r: any, a: any) => {
            if (a.parentKey && a.parentKey !== 'null') {
                r[a.parentKey] = r[a.parentKey] || {};
                r[a.parentKey][a.keyName] = a.selectedItems;
                return r;
            } else {
                r[a.keyName] = r[a.keyName] || {};
                r[a.keyName] = a.selectedItems;
                return r;
            }
        }, Object.create(null));
        for (const key in tenantObj) {
            if (this.settingsHasMultipleSettings.includes(key)) {
                if (Object.prototype.hasOwnProperty.call(tenantObj, key)) {
                    if (key && key !== 'null') {
                        const config: any = {};
                        config.tenant_key = key;
                        config.value = JSON.stringify({ ...tenantSettingsOriginals[key], ...tenantObj[key] });
                        config.setting_visibility = that.getVisiblitySetting(key, true);
                        sendData.push(config);
                    }
                }
            } else {
                const config: any = {};
                config.tenant_key = key;
                config.value = tenantObj[key];
                config.setting_visibility = that.getVisiblitySetting(key, false);
                sendData.push(config);
            }
        }
        for await (const [index, iterator] of sendData.entries()) {
            tenantSettingsAPI.updateTenantSettings(iterator).then(() => {
                that.isUpdating = false;
                that.$bvModal.hide('tenant-confirmation');
                if (index === sendData.length - 1) {
                    tenantSettingsAPI.fetchActiveTenantSettings().then((settingsList: any) => {
                        that.tenantSettingsOriginals = settingsList;
                        sessionService.saveUpdatedTenantSettings(settingsList);
                        updatedSettings.forEach((element: any) => {
                            const logo = 'ui_element_visibility_settings~show_logo';
                            if (element.settingKey === logo) {
                                that.updateHeaderLogo(true);
                            }
                        });
                    });
                }
            });
        }
    }

    private onChange(tenantOpt: any) {
        this.checkCurrentUpdates(tenantOpt);
    }

    private onChangeChildConfig(tenantOpt: any) {
        this.checkCurrentUpdates(tenantOpt);
    }

    private checkCurrentUpdates(tenantOpt: any) {
        const itemIndex = this.updatedItemArray.findIndex((item: any) => item.keyName === tenantOpt.keyName);
        if (itemIndex === -1) {
            this.updatedItemArray.push(tenantOpt);
        }
    }

    private checkValueAvailable(activeComponent: any) {
        for (const key in activeComponent) {
            if (Object.prototype.hasOwnProperty.call(activeComponent, key)) {
                const element = activeComponent[key];
                if (element.fieldType === 'b-form-checkbox') {
                    if (this.tenantSettings[element.keyName]) {
                        const doNothing = 'doNothing';
                    } else {
                        this.tenantSettings[element.keyName] = false;
                    }
                }
            }
        }
    }

    private async getUpdatedSettings() {
        this.displayTenantSettings = [];
        this.selectedTenantSettings = [];
        const elementTenant = this.tenantElement;
        const specialCases = ['ca_content_sources'];
        const originalSettings = JSON.parse(JSON.stringify(this.tenantSettingsOriginals));
        for (const key in elementTenant) {
            if (Object.prototype.hasOwnProperty.call(elementTenant, key)) {
                const element = elementTenant[key];
                if (element && element.accessMode === 'view') {
                    continue;
                }
                if (isEmptyValue(this.tenantSettings[element.parentKey]) || this.tenantSettings[element.parentKey] === 'null') {
                    if (specialCases.includes(element.keyName)) {
                        if (Array.isArray(this.tenantSettings[element.keyName])) {
                            if (element.keyName === 'ca_content_sources') {
                                if (JSON.stringify(originalSettings[element.keyName]) !==
                                    JSON.stringify(this.tenantSettings[element.keyName])) {
                                    element.selectedItems = this.tenantSettings[element.keyName];
                                    this.selectedTenantSettings.push(element);
                                } else {
                                    const orgOpenLibIndex = originalSettings[element.keyName].
                                        findIndex((item: any) => {
                                            return item.key === 'open-library';
                                        });
                                    const updatedOpenLibIndex = this.tenantSettings[element.keyName].
                                        findIndex((item: any) => {
                                            return item.key === 'open-library';
                                        });
                                    if (orgOpenLibIndex === -1) {
                                        if (updatedOpenLibIndex !== -1) {
                                            element.selectedItems = this.tenantSettings[element.keyName];
                                            this.selectedTenantSettings.push(element);
                                        }
                                    } else {
                                        if (updatedOpenLibIndex === -1) {
                                            element.selectedItems = this.tenantSettings[element.keyName];
                                            this.selectedTenantSettings.push(element);
                                        } else {
                                            const elem0 = originalSettings[element.keyName][orgOpenLibIndex].
                                                libraries.default;
                                            const elem1 = this.tenantSettings[element.keyName][updatedOpenLibIndex].
                                                libraries.default;
                                            const checkDiff = diffArray(elem0, elem1);
                                            if (checkDiff.length > 0) {
                                                element.selectedItems = this.tenantSettings[element.keyName];
                                                this.selectedTenantSettings.push(element);
                                            }
                                        }
                                    }
                                    const orgTenantLibIndex = originalSettings[element.keyName].
                                        findIndex((item: any) => {
                                            return item.key === 'tenant-library';
                                        });
                                    const updatedTenantLibIndex = this.tenantSettings[element.keyName]
                                        .findIndex((item: any) => {
                                            return item.key === 'tenant-library';
                                        });
                                    if (orgTenantLibIndex === -1) {
                                        if (updatedTenantLibIndex !== -1) {
                                            element.selectedItems = this.tenantSettings[element.keyName];
                                            const checkFinalIndex = this.selectedTenantSettings.
                                                findIndex((item: any) => {
                                                    return item.keyName === element.keyName;
                                                });
                                            if (checkFinalIndex === -1) {
                                                this.selectedTenantSettings.push(element);
                                            }
                                        }
                                    } else {
                                        if (updatedTenantLibIndex === -1) {
                                            element.selectedItems = this.tenantSettings[element.keyName];
                                            const checkFinalIndex = this.selectedTenantSettings.
                                                findIndex((item: any) => {
                                                    return item.keyName === element.keyName;
                                                });
                                            if (checkFinalIndex === -1) {
                                                this.selectedTenantSettings.push(element);
                                            }
                                        } else {
                                            const orgi = originalSettings[element.keyName][orgTenantLibIndex];
                                            const tenant = this.tenantSettings[element.keyName][updatedTenantLibIndex];
                                            const elem0 = orgi && orgi.libraries && orgi.libraries.default ?
                                            orgi.libraries.default : [];
                                            const elem1 = tenant && tenant.libraries && tenant.libraries.default ?
                                            tenant.libraries.default : [];
                                            const checkDiff = diffArray(elem0, elem1);
                                            if (checkDiff.length > 0) {
                                                element.selectedItems = this.tenantSettings[element.keyName];
                                                const checkFinalIndex = this.selectedTenantSettings.
                                                    findIndex((item: any) => {
                                                        return item.keyName === element.keyName;
                                                    });
                                                if (checkFinalIndex === -1) {
                                                    this.selectedTenantSettings.push(element);
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }

                    } else if (JSON.stringify(originalSettings[element.keyName]) !==
                    JSON.stringify(this.tenantSettings[element.keyName])) {
                        element.selectedItems = this.tenantSettings[element.keyName];
                        this.selectedTenantSettings.push(element);
                    }
                } else {
                    if (originalSettings && originalSettings[element.parentKey] &&
                        originalSettings[element.parentKey][element.keyName] !==
                        this.tenantSettings[element.parentKey][element.keyName]) {
                        if (this.tenantSettings[element.parentKey][element.keyName] instanceof File) {
                            element.imageURL =
                                URL.createObjectURL(this.tenantSettings[element.parentKey][element.keyName]);
                            element.selectedItems = this.tenantSettings[element.parentKey][element.keyName];
                        } else {
                            if (element.selectedItems instanceof File &&
                                this.tenantSettings[element.parentKey][element.keyName] === null) {
                                element.imageURL = null;
                                element.selectedItems = this.tenantSettings[element.parentKey][element.keyName];
                            } else {
                                element.selectedItems = this.tenantSettings[element.parentKey][element.keyName];
                            }
                        }
                        this.selectedTenantSettings.push(element);
                    }
                }
            }
        }
        this.displayTenantSettings = await this.prepareDisplayData(this.selectedTenantSettings);
        this.$bvModal.show('tenant-confirmation');
    }

    private updateHeaderLogo(url: any) {
        EventBus.$emit('updateHeaderIcon', url);
    }

    private async getCategorySubject() {
        this.categoryList = await taxonomyAPI.fetchTaxonomyClassifications();
        for await (const [index, iterator] of this.categoryList.entries()) {
            const subjectList = await taxonomyAPI.fetchSubjects(iterator.id);
            iterator.subjects = subjectList;
        }
    }

    private async prepareDisplayData(callback: any) {
        for await (const iterator of this.selectedTenantSettings) {
            if (iterator.settingKey === 'roster_subject_keywords'
                || iterator.settingKey === 'navigator_route_map_view_applicable'
            ) {
                // for iterator.selectedItems
                iterator.displayData = [];
                for (const prop in iterator.selectedItems) {
                    if (iterator.selectedItems.hasOwnProperty(prop)) {
                        const propSplit = prop.split('.');
                        const data: any = {
                            keyName: prop,
                            keyValue: iterator.selectedItems[prop],
                            displayValue: iterator.selectedItems[prop].toString(),
                            categoryId: propSplit[0],
                            subjectId: prop,
                            displayName: this.getName(prop, 'subject'),
                        };
                        iterator.displayData.push(data);
                    }
                }
            } else if (iterator.settingKey === 'enable_milestone_view_at_fw_level'
                || iterator.settingKey === 'mastery_on_content_completion_setting'
                || iterator.settingKey === 'competency_completion_min_score'
                || iterator.settingKey === 'minimum_starting_grade_for_diagnostic_flow'
                || iterator.settingKey === 'default_view_sns_at_fw_level'
            ) {
                iterator.displayData = [];
                for (const prop in iterator.selectedItems) {
                    if (iterator.selectedItems.hasOwnProperty(prop)) {
                        const propSplit = prop.split('.');
                        const data: any = {
                            keyName: prop,
                            keyValue: iterator.selectedItems[prop],
                            displayValue: Array.isArray(iterator.selectedItems[prop]) ?
                                iterator.selectedItems[prop].toString() : iterator.selectedItems[prop],
                            categoryId: propSplit[1],
                            subjectId: `${propSplit[1]}.${propSplit[2]}`,
                            displayName: this.getName(prop, 'framework'),
                        };
                        if (iterator.settingKey === 'minimum_starting_grade_for_diagnostic_flow') {
                            const gradeList = await this.getGrdaesWithFWCode(data.subjectId, propSplit[0]);
                            const selectedGradeIndex = gradeList.findIndex((item: any) => {
                                return item.id === data.keyValue;
                            });
                            if (selectedGradeIndex !== -1) {
                                data.displayValue = gradeList[selectedGradeIndex].grade;
                            }
                        }
                        iterator.displayData.push(data);
                    }
                }
            } else if (iterator.settingKey === 'default_groups') {
                iterator.displayData = [];
                const countriesGroup: any = await taxonomyAPI.fetchTaxonomyCountry();
                const params: any = {
                    id: iterator.selectedItems.country,
                };
                const stateGroup: any = await taxonomyAPI.fetchTaxonomyState(params);
                const countryList: any = countriesGroup.groups;
                const stateList: any = stateGroup.groups;
                const selectedCountry = countryList.find((item: any) => {
                    return item.id === iterator.selectedItems.country;
                });
                const selectedState = stateList.find((item: any) => {
                    return item.id === iterator.selectedItems.state;
                });
                const countryData: any = {
                    displayName: 'country',
                    displayValue: selectedCountry.name,
                };
                iterator.displayData.push(countryData);
                const stateData: any = {
                    displayName: 'state',
                    displayValue: selectedState.name,
                };
                iterator.displayData.push(stateData);
            } else if (iterator.settingKey === 'enable_marker') {
                iterator.displayData = [];
                const selectedArray = iterator.selectedItems || [];
                for (const prop of selectedArray) {
                        // const propSplit = prop.split('.');
                        const data: any = {
                            displayName: this.getName(prop, 'framework'),
                        };
                        iterator.displayData.push(data);
                }
            }
        }
        return this.selectedTenantSettings;
        // callback(this.selectedTenantSettings);
    }

    private getName(prop: any, namefrom: any) {
        const propSplit = prop.split('.');
        let category: any = {};
        let subject: any = {};
        let fw: any = {};
        if (namefrom === 'subject') {
            category = this.categoryList.find((item: any) => item.code === propSplit[0]);
            subject = category.subjects.find((item: any) => item.id === prop);
        } else if (namefrom === 'framework') {
            category = this.categoryList.find((item: any) => item.code === propSplit[1]);
            subject = category.subjects.find((item: any) => item.id === `${propSplit[1]}.${propSplit[2]}`);
            fw = subject.frameworks.find((item: any) => item.taxonomy_subject_id === prop);
        }
        let name = '';
        switch (namefrom) {
            case 'category':
                name = category && category.title ? category.title : '';
                break;
            case 'subject':
                name = subject && subject.title ? subject.title : '';
                break;
            case 'framework':
                name = fw && fw.title ? fw.title : '';
                break;
        }

        return name;
    }

    private getGrdaesWithFWCode(subjectId: any, fwCode: any) {
        return taxonomyAPI.fetchTaxonomyGradesWithFwCode(subjectId, fwCode).then((courses) => {
            return courses ? courses : [];
        });
    }

    private checkDefaultDDSelection(activeComponent: any) {
        for (const key in activeComponent) {
            if (Object.prototype.hasOwnProperty.call(activeComponent, key)) {
                const element = activeComponent[key];
                if (element.fieldType === 'b-form-select' && element.selectOption && element.selectOption.options) {
                    const optionItem: any = element.selectOption.options.find((item: any) => item.is_default);
                    if (optionItem && optionItem.is_default) {
                        if (element.parentKey) {
                            if (isEmptyValue(this.tenantSettings[element.parentKey][element.keyName])) {
                                this.tenantSettings[element.parentKey][element.keyName] = optionItem.value;
                            }
                        } else {
                            if (isEmptyValue(this.tenantSettings[element.keyName])) {
                                this.tenantSettings[element.keyName] = optionItem.value;
                            }
                        }
                    }
                }
            }
        }
    }
}
